import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative bg-gradient-to-br from-primary via-secondary to-primary py-20 lg:py-28 ${className}`}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-accent" variant="solid" />
            <span className="text-sm font-medium text-white">Your AI Transformation Starts Here</span>
          </div>
          
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-display font-bold text-white mb-6 leading-tight">
            Demystifying AI for <span className="text-accent">Business Growth</span>
          </h1>
          
          <p className="text-lg lg:text-xl text-white/90 mb-8 leading-relaxed">
            Transform complexity into clarity with our comprehensive guides, interactive tools, and proven strategies for AI implementation. Your journey from AI-curious to AI-powered starts here.
          </p>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">500+</div>
              <div className="text-sm text-white/80">Successful Implementations</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">87%</div>
              <div className="text-sm text-white/80">Average ROI Increase</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">24/7</div>
              <div className="text-sm text-white/80">Expert Support Access</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;